import { X } from 'lucide-react'
import { Alert, AlertDescription, Button } from '@axilon-apps/libs-ui-shadcn'
import { FlashMessage } from '@axilon-apps/libs-ui-types'

import getAlertVariantByMessageType from './utils/get-alert-color-by-message-type'

interface Props {
  message: FlashMessage
  onClose: (message: FlashMessage) => void
}

const FlashMessageItem = ({ message, onClose }: Props) => {
  const variant = getAlertVariantByMessageType(message.type)

  const close = () => onClose(message)

  return (
    <Alert variant={variant} className="flex items-start justify-between gap-2">
      <AlertDescription className="flex-1">{message.message}</AlertDescription>
      <Button
        variant="ghost"
        size="icon-sm"
        onClick={close}
        aria-label="Dismiss"
        className="-mr-1 -mt-1"
      >
        <X />
      </Button>
    </Alert>
  )
}

export default FlashMessageItem
